<ng-container *ngLet="availableDomains$ | async as availableDomains"
              [formGroup]="controlContainer.control">
    <ng-container *uiContentLoading="availableDomains == null">
        <mat-form-field>
            <ui-suggest #domainSuggest
                        [clearable]="false"
                        [displayCount]="4"
                        [items]="availableDomains"
                        [formControlName]="UserGroupField.Domain"
                        [placeholder]="'user_import_modal_form_domain_name' | translate"
                        [required]="true"
                        (selected)="form.get(UserGroupField.UserName)!.setValue(null)"
                        data-cy="domain">
            </ui-suggest>
        </mat-form-field>

        <div class="ad-search-query-container">
            <mat-form-field class="ad-search-query-input">
                <ui-suggest #groupSuggest
                            [clearable]="false"
                            [displayCount]="4"
                            [searchable]="true"
                            [disabled]="!domainSuggest.value[0]"
                            [searchSourceFactory]="adSearchFactory(searchContextControl.value)"
                            [formControlName]="UserGroupField.UserName"
                            [uiRestrictInput]="restrictInputRegex"
                            [placeholder]="'user_import_modal_form_user_or_group_name' | translate"
                            [required]="true"
                            data-cy="userName">
                </ui-suggest>

                <mat-hint *ngIf="!groupSuggest?.value[0]?.id">{{ userOrGroupHint | translate }}</mat-hint>
            </mat-form-field>

            <mat-form-field class="ad-search-query-type">
                <mat-select #searchContextControl
                            [value]="searchContextOptions[0].value"
                            [placeholder]="'user_search_query_type' | translate"
                            (valueChange)="form.get(UserGroupField.UserName)!.setValue(null)"
                            data-cy="queryType">
                    <mat-option *ngFor="let searchOption of searchContextOptions"
                                [value]="searchOption.value">
                        {{ searchOption.translationKey | translate }}
                    </mat-option>
                </mat-select>

                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
            </mat-form-field>
        </div>
    </ng-container>
</ng-container>
